import React, { useEffect, useMemo, useState } from "react";
import { Route, Switch, Link, useRouteMatch } from "react-router-dom";
import { IconButton } from "@material-ui/core";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  Dialog,
  CircularProgress,
  TextField,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  Typography,
  Icon,
  Divider,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";

import {
  CloudQueue,
  Create,
  Done,
  DoneAll,
  HourglassEmpty,
  RateReview,
} from "@material-ui/icons";

import DragIndicatorIcon from "@material-ui/icons/DragIndicator";

import { fetchImageAsFile } from "views/Dashboard/Course/CourseConstants";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CardTitle from "components/Card/CardTitle";
import NewCardBody from "components/Card/NewCardBody";
import HeadingWithDescription from "components/Heading/HeadingWithDescription.js";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";

// context
import NotificationContext from "views/Components/Context.js";

// colors
import { quCreateColor } from "assets/jss/material-dashboard-pro-react";

// data and utilities
import { moduleStages } from "./Data/moduleStages";
import {
  fetchAllLecturesAPI,
  fetchAllWritingsAPI,
  addArtifactToCourse,
  submitCourseForPublishing,
  fetchQUSkillBridgeCourseID,
  fetchAllLabsAPI,
  fetchWritingTemplatesAPI,
  fetchAllPodcastsAPI,
  createPodcastAPI,
  createLabAPI,
  createWritingAPI,
  updateCourseDetails,
  addModuleToCourse,
  deleteModuleAPI,
  deleteArtifactAPI,
  addArtifactsToCourse,
} from "views/APIs/APIUtility";
import SearchBar from "material-ui-search-bar";
import CreateAssetDialog from "./CreateAssetDialog";
// Modals
import CreatePodcastModal from "views/Components/CreatePodastModal";
import CreateLabModal from "views/Components/CreateLabModal";
import CreateWritingModal from "views/Components/CreateWritingModal.js";
import CreateModuleModal from "views/Components/CreateModuleModal.js";

// Models
import BaseDetails from "./Models/BaseDetails";
import PodcastDetails from "./Models/PodcastDetails";
import LabDetails from "./Models/LabDetails";
import WritingModel from "./Models/WritingModel";
import { image_name, identifiers } from "./Constants";
import Alert from "views/Components/Alert";

import {
  DndContext,
  closestCenter,
  DragOverlay,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  arrayMove,
  rectSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ArtifactTable from "./ArtifactTable";

const useStyles = makeStyles(styles);
const usedashboardStyle = makeStyles(dashboardStyle);

export default function ModulesDesign(props) {
  // Import necessary hooks and styles
  const dashboardClasses = usedashboardStyle();
  const classes = useStyles();
  const images = require.context("assets/img", true);
  const assetImages = require.context("assets/img/create_cards_16_9", true);
  // State variables for managing UI and data
  const [modulesLoading, setModulesLoading] = useState(true);
  const [moduleModal, setModuleModal] = useState(false);
  const [assetModal, setAssetModal] = useState(false);
  const [additionalArtifacts, setAdditionalArtifacts] = useState([]);
  const [name, setName] = useState("");
  const [brief, setBrief] = useState("");
  const [project, setProject] = useState({});
  const [course, setCourse] = useState({ modules: [] });

  const [submitModuleLoading, setSubmitModuleLoading] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importLoading, setImportLoading] = useState({
    loading: false,
    message: "",
  });
  const [selectedArtifact, setSelectedArtifact] = useState(null);
  const [artifacts, setArtifacts] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [displayModules, setDisplayModules] = useState();
  const [
    displayAdditionalArtifacts,
    setDisplayAdditionalArtifacts,
  ] = useState();
  const [searchValue, setSearchValue] = useState("");

  // Context and route match hooks
  const { showNotification } = React.useContext(NotificationContext);
  const { path, url } = useRouteMatch();
  const { courseID } = props.match.params;

  // Log the course ID for debugging
  // Writing ID state (note: TODO; remove writing_id later)
  const [writingId, setWritingId] = React.useState("");
  const [currentDialog, setCurrentDialog] = React.useState("Create Writing");
  const [identifier, setIdentifier] = React.useState("research_report");
  const [identifierPrint, setIdentifierPrint] = React.useState(
    identifiers["research_report"]
  );
  const [writingCreationLoader, setWritingCreationLoader] = React.useState({
    isLoading: false,
    message: "",
  });

  // state variables
  const [createPodcastModal, setCreatePodcastModal] = React.useState(false);
  const [newPodcastDetails, setNewPodcastDetails] = React.useState(
    new PodcastDetails()
  );
  const [newLabDetails, setNewLabDetails] = React.useState(new LabDetails());
  const [newWritingDetails, setNewWritingDetails] = React.useState(
    new WritingModel()
  );
  const [moduleDetails, setModuleDetails] = React.useState(new BaseDetails());

  const [podcastCreationLoader, setPodcastCreationLoader] = React.useState(
    false
  );
  const [iconImage, setIconImage] = React.useState();

  const [createLabModal, setCreateLabModal] = React.useState(false);
  const [createWritingModal, setCreateWritingModal] = React.useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  const DEBUG = false;

  const arraysEqual = (a = [], b = []) =>
    a.length === b.length && a.every((v, i) => v === b[i]);

  const itemsEqualById = (a = [], b = []) => {
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i]?.id !== b[i]?.id) return false;
    }
    return true;
  };

  const handleIconUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setIconImage(file);
    }
  };

  // Define table columns
  const columns = useMemo(
    () => [
      {
        Header: "Select",
        id: "select",
        Cell: ({ row }) => (
          <input
            type="radio"
            name="rowSelection"
            checked={selectedArtifact === row.original.artifact_id}
            onChange={() => setSelectedArtifact(row.original.artifact_id)}
          />
        ),
        disableSortBy: true,
        disableFilters: true,
      },
      { Header: "Name", accessor: "artifact_name" },
      { Header: "Description", accessor: "artifact_description" },
      { Header: "Type", accessor: "artifact_type" },
    ],
    [selectedArtifact]
  );

  // Fetch course data on component mount
  useEffect(() => {
    fetch(process.env.REACT_APP_FASTAPI_URL + `/get_course/${courseID}`)
      .then((res) => res.json())
      .then((data) => {
        setCourse(data);
        const additional_artifacts = [];
        if (data.additional_artifacts) {
          data.additional_artifacts.forEach((artifact) => {
            if ("lecture_name" in artifact) {
              additional_artifacts.push({
                artifact_id: artifact._id,
                artifact_name: artifact.lecture_name,
                artifact_description: artifact.lecture_description,
                artifact_image: artifact.lecture_image,
                artifact_type: "Lecture",
              });
            } else if ("writing_name" in artifact) {
              additional_artifacts.push({
                artifact_id: artifact._id,
                artifact_name: artifact.writing_name,
                artifact_description: artifact.writing_description,
                artifact_image: artifact.writing_image,
                // artifact_type: "Writing",
                artifact_type: artifact.identifier,
              });
            } else if ("podcast_name" in artifact) {
              additional_artifacts.push({
                artifact_id: artifact._id,
                artifact_name: artifact.podcast_name,
                artifact_description: artifact.podcast_description,
                artifact_image: artifact.podcast_image,
                // artifact_type: "Writing",
                artifact_type: "podcast",
              });
            } else if ("lab_name" in artifact) {
              additional_artifacts.push({
                artifact_id: artifact._id,
                artifact_name: artifact.lab_name,
                artifact_description: artifact.lab_description,
                artifact_image: artifact.lab_image,
                artifact_type: "Lab",
              });
            } else {
            }
          });
          setDisplayModules(data.modules);
          setAdditionalArtifacts(additional_artifacts);
          setDisplayAdditionalArtifacts(additional_artifacts);
          setOrderIds(data?.display_order ?? []);
        }
      })
      .catch((err) => {
        console.log(err);
        showNotification("Error fetching course data", "danger");
      })
      .finally(() => {
        setModulesLoading(false);
      });
  }, [courseID]);

  // Status icons for different module stages
  const statusIcons = [
    <Create />,
    <CloudQueue />,
    <RateReview />,
    <CloudQueue />,
    <RateReview />,
    <CloudQueue />,
    <RateReview />,
    <CloudQueue />,
    <RateReview />,
    <CloudQueue />,
    <DoneAll />,
  ];

  // Get the status icon based on the module status
  const getStatusIcon = (status) => {
    const index = moduleStages.indexOf(status);
    return statusIcons[index];
  };

  // Add a new module to the course
  const addModule = async () => {
    setSubmitModuleLoading(true);
    try {
      const formData = new FormData();
      formData.append("course_id", courseID);
      formData.append("module_name", moduleDetails.name);
      formData.append("module_description", moduleDetails.description);

      const response = await addModuleToCourse(formData);

      if (response.modules) {
        setCourse(response);
        setDisplayModules(response.modules);
      }
      showNotification("Module added successfully", "success");
    } catch (err) {
      showNotification("Error adding module", "danger");
    } finally {
      setSubmitModuleLoading(false);
      handleAssetModalClose();
    }
  };

  const addAsset = async (card) => {
    setAssetModal(false);
    if (card.identifier === "podcast") {
      setCreatePodcastModal(true);
    } else if (card.identifier === "labs") {
      setCreateLabModal(true);
    } else if (Object.keys(identifiers).includes(card.identifier)) {
      setIdentifier((prev) => {
        setIdentifierPrint(identifiers[card.identifier]);
        setCreateWritingModal(true); // Now that states are set, open the modal
        return card.identifier;
      });
    } else if (card.identifier === "module") {
      setModuleModal(true);
    }
  };

  // Get a list of unique artifact types
  const artifactTypes = [
    "All",
    ...new Set(artifacts.map((artifact) => artifact.artifact_type)),
  ];

  // Filter artifacts based on selected tab
  const filteredArtifacts =
    selectedTab === "All"
      ? artifacts
      : artifacts.filter((artifact) => artifact.artifact_type === selectedTab);

  const handleImportArtifact = async (courseID, artifact_id, artifact_type) => {
    try {
      const formData = new FormData();
      formData.append("course_id", courseID);
      formData.append("artifact_id", artifact_id);
      formData.append("artifact_type", artifact_type);
      await addArtifactToCourse(formData);
      window.location.reload();
    } catch (error) {
      return error;
    }
  };

  // Import ALL selectedIds at once
  const importArtifacts = async () => {
    try {
      setImportLoading({ loading: true, message: "Importing artifacts..." });

      // Guard
      if (!selectedIds || selectedIds.length === 0) {
        showNotification("Select at least one artifact", "warning");
        return;
      }

      // Build a quick lookup: id -> type (from filteredArtifacts)
      const typeById = new Map(
        (filteredArtifacts || []).map((a) => [a.artifact_id, a.artifact_type])
      );

      // Dedupe IDs to be safe
      const uniqueIds = Array.from(new Set(selectedIds));

      // Prepare FormData with repeated keys
      const formData = new FormData();
      formData.append("course_id", courseID);

      const missing = [];
      uniqueIds.forEach((id) => {
        const t = typeById.get(id);
        if (!t) {
          missing.push(id);
          return;
        }
        formData.append("artifact_ids", id);
        formData.append("artifact_types", t);
      });

      if (missing.length) {
        showNotification(
          `Skipped ${missing.length} item(s) with unknown type.`,
          "warning"
        );
      }

      // Call your API once for all artifacts
      await addArtifactsToCourse(formData);
      window.location.reload();

      showNotification(
        `Imported ${uniqueIds.length - missing.length} artifacts`,
        "success"
      );

      // Optional: clear selection and refresh UI
      setSelectedIds([]);
      // If you really need a hard refresh, uncomment:
      // window.location.reload();
    } catch (error) {
      console.error(error);
      showNotification("Error importing artifacts", "danger");
    } finally {
      setImportLoading({ loading: false, message: "" });
    }
  };

  // Fetch all artifacts (writings, lectures, labs)
  const getArtifacts = async () => {
    const writings = await fetchAllWritingsAPI();
    // const lectures = await fetchAllLecturesAPI();
    const labs = await fetchAllLabsAPI();
    const podcasts = await fetchAllPodcastsAPI();
    const artifacts = [];
    writings.forEach((writing) => {
      artifacts.push({
        artifact_id: writing._id,
        artifact_name: writing.writing_name,
        artifact_type: identifiers[writing.identifier] || "Writing",
        artifact_description: writing.writing_description,
      });
    });
    // lectures.forEach((lecture) => {
    //   artifacts.push({
    //     artifact_id: lecture._id,
    //     artifact_name: lecture.lecture_name,
    //     artifact_type: "Lecture",
    //     artifact_description: lecture.lecture_description,
    //   });
    // });
    labs.forEach((lab) => {
      artifacts.push({
        artifact_id: lab._id,
        artifact_name: lab.lab_name,
        artifact_type: "Lab",
        artifact_description: lab.lab_description,
      });
    });
    podcasts.forEach((podcast) => {
      artifacts.push({
        artifact_id: podcast._id,
        artifact_name: podcast.podcast_name,
        artifact_type: "Podcast",
        artifact_description: podcast.podcast_description,
      });
    });

    // filter out the writings whose artifact_type is Writing
    let filteredArtifacts = artifacts.filter(
      (artifact) => artifact.artifact_type !== "Writing"
    );
    setArtifacts(filteredArtifacts);
  };

  // Fetch artifacts on component mount
  useEffect(() => {
    getArtifacts();
  }, []);

  // Handle publishing the course
  const handlePublishCourse = async () => {
    const form = new FormData();
    try {
      form.append("course_id", courseID);
      await submitCourseForPublishing(form);
    } catch (err) {
      showNotification("Error publishing course", "danger");
    } finally {
      showNotification(
        "Your course is marked for publishing. You will be notified shortly.",
        "success"
      );
    }
  };

  // Handle previewing the course
  const handlePreviewCourse = async () => {
    try {
      const response = await fetchQUSkillBridgeCourseID(courseID);
      if (response) {
        window.open(
          `https://quskillbridge.qusandbox.com/course-information/${response}`,
          "_blank"
        );
      } else {
        showNotification("Failed to fetch course preview.", "danger");
      }
    } catch (error) {
      showNotification(
        "An error occurred while fetching the course preview.",
        "danger"
      );
    }
  };

  // Handle updating course details
  const handleCourseDetailsChange = async (courseDetails) => {
    try {
      const formData = new FormData();
      formData.append("course_id", courseID);
      formData.append("course_name", courseDetails.title);
      formData.append("course_description", courseDetails.shortDescription);
      formData.append("course_outline", courseDetails.longDescription);

      await updateCourseDetails(formData);
      setCourse((prevCourse) => ({
        ...prevCourse,
        course_name: courseDetails.title,
        course_description: courseDetails.shortDescription,
        course_outline: courseDetails.longDescription,
      }));
      showNotification("Course details updated successfully", "success");
    } catch (error) {
      showNotification(
        "An error occurred while updating course details.",
        "danger"
      );
    } finally {
    }
  };

  const searchInputValue = (e) => {
    setSearchValue(e);
    if (e == "") {
      setDisplayModules(course.modules);
      setDisplayAdditionalArtifacts(additionalArtifacts);
      return;
    }
    var newList = course.modules.filter(
      (module) =>
        module.module_name.toLowerCase().includes(e.toLowerCase()) ||
        module.module_description.toLowerCase().includes(e.toLowerCase())
    );
    setDisplayModules(newList);
    var newAdditionalList = additionalArtifacts.filter(
      (artifact) =>
        artifact.artifact_name.toLowerCase().includes(e.toLowerCase()) ||
        artifact.artifact_description.toLowerCase().includes(e.toLowerCase())
    );
    setDisplayAdditionalArtifacts(newAdditionalList);
  };

  const handleAssetModalClose = () => {
    // Close the main modal
    setAssetModal(false);

    //Initialize the sub modals to false
    setCreatePodcastModal(false);
    setCreateLabModal(false);
    setCreateWritingModal(false);
    setModuleModal(false);
    //Miscealenous
    setWritingCreationLoader({ isLoading: false, message: "" });
    setCurrentDialog("Create Writing");
    setIconImage(null);
    // Reset objects
    setNewPodcastDetails(new PodcastDetails());
    setNewLabDetails(new LabDetails());
    setNewWritingDetails(new WritingModel());
    setModuleDetails(new BaseDetails());
  };

  const handleCreatePodcast = async (modulesAtCreation = true) => {
    setPodcastCreationLoader(true);
    const imageToUse =
      iconImage || (await fetchImageAsFile(assetImages("./podcast.png")));
    // const imageToUse = iconImage || images("./qusandbox_logo_v2.5.png");
    const formData = new FormData();
    formData.append("podcast_name", newPodcastDetails.name);
    formData.append("podcast_description", newPodcastDetails.description);
    formData.append("podcast_image", imageToUse);
    formData.append("podcast_transcript", newPodcastDetails.podcastOutline);
    newPodcastDetails.uploadedFiles.forEach((file) => {
      formData.append("files", file);
    });

    try {
      const data = await createPodcastAPI(formData);
      await handleImportArtifact(courseID, data._id, "Podcast");
      window.location.reload();
      showNotification("Podcast created successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setPodcastCreationLoader(false);
      handleAssetModalClose();
    }
  };

  const handleCreateLab = async () => {
    // setLoading({ loading: true, message: "Creating Lab..." });
    const formData = new FormData();
    formData.append("lab_name", newLabDetails.name);
    formData.append("lab_description", newLabDetails.description);
    formData.append("lab_outline", newLabDetails.labOutline);
    newLabDetails.uploadedFiles.forEach((file) => {
      formData.append("files", file);
    });
    formData.append(
      "lab_image",
      iconImage || (await fetchImageAsFile(assetImages("./labs.png")))
    );

    try {
      const data = await createLabAPI(formData);
      await handleImportArtifact(courseID, data._id, "Lab");
      showNotification("Lab created successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      handleAssetModalClose();
      // setLoading({ loading: false, message: "" });
    }
  };

  const handleCreateWriting = async () => {
    try {
      // Fetch image
      const imageToUse =
        iconImage ||
        (await fetchImageAsFile(assetImages(image_name[identifier])));

      // Prepare form data
      const formData = new FormData();
      formData.append("writing_id", writingId);
      formData.append("writing_name", newWritingDetails.name);
      formData.append("writing_description", newWritingDetails.description);
      formData.append("writing_image", imageToUse);
      formData.append("writing_outline", newWritingDetails.outline);
      formData.append("identifier", identifier);

      // Append additional files
      newWritingDetails.uploadedFiles.forEach((file) => {
        formData.append("files", file);
      });

      const data = await createWritingAPI(formData);
      window.open(`/create/${identifier}/${data._id}`, "_blank");
      await handleImportArtifact(courseID, data._id, "Writing");

      showNotification(identifierPrint + " created successfully", "success");
    } catch (error) {
      console.error("Error occurred:", error);
      showNotification(error, "danger");
    } finally {
      handleAssetModalClose();
    }
  };

  const handleGenerateTemplate = async (prompt, use_metaprompt) => {
    try {
      setWritingCreationLoader({
        isLoading: true,
        message: `Let's create some templates for the ${identifierPrint}...`,
      });
      const formData = new FormData();
      formData.append("identifier", identifier);
      // Append any additional files
      newWritingDetails.uploadedFiles.forEach((file) => {
        formData.append("files", file);
      });
      formData.append("target_audience", newWritingDetails.target_audience);
      formData.append("expected_length", newWritingDetails.expected_length);
      formData.append("tone", newWritingDetails.tone);

      formData.append("prompt", prompt);
      formData.append("use_metaprompt", use_metaprompt);
      const data = await fetchWritingTemplatesAPI(formData);
      const formattedTemplates = (data.templates || []).map((item) => ({
        template_name: (item.template_name || "Unnamed")
          .replace(/\s*template\s*$/i, "")
          .trim(),
        template_content: item.template_content || "No content available",
      }));

      // Update state with the new template data
      setNewWritingDetails((prevState) => ({
        ...prevState,
        template: formattedTemplates,
      }));
    } catch (error) {
      showNotification(error, "danger");
    } finally {
      setWritingCreationLoader({ isLoading: false, message: "" });
    }
  };

  const [showAlert, setShowAlert] = useState(false);

  const [artifactToDelete, setArtifactToDelete] = useState(null);
  const [moduleToDelete, setModuleToDelete] = useState(null);

  const handleCancel = () => {
    setShowAlert(false);
    setModuleToDelete(null);
    setArtifactToDelete(null);
  };

  const handleConfirm = () => {
    setShowAlert(false);
    if (moduleToDelete) {
      handleDeleteModule(moduleToDelete);
    } else if (artifactToDelete) {
      handleDeleteArtifact(artifactToDelete);
    }
  };

  const handleDeleteArtifact = async (artifactID) => {
    try {
      const formData = new FormData();
      formData.append("artifact_id", artifactID);
      formData.append("course_id", courseID);
      await deleteArtifactAPI(formData);

      // Update local state (no reload)
      setAdditionalArtifacts((prev) =>
        prev.filter((a) => a.artifact_id !== artifactID)
      );
      setDisplayAdditionalArtifacts((prev) =>
        (prev || []).filter((a) => a.artifact_id !== artifactID)
      );
      setOrderIds((prev) => prev.filter((id) => id !== artifactID));
      showNotification("Artifact deleted successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    }
  };

  const handleDeleteModule = async (moduleID) => {
    try {
      const formData = new FormData();
      formData.append("module_id", moduleID);
      formData.append("course_id", courseID);
      await deleteModuleAPI(formData);

      // Update course + derived views
      setCourse((prev) => ({
        ...prev,
        modules: (prev.modules || []).filter(
          (m) => (m.module_id || m._id) !== moduleID
        ),
      }));
      setDisplayModules((prev) =>
        (prev || []).filter((m) => (m.module_id || m._id) !== moduleID)
      );
      setOrderIds((prev) => prev.filter((id) => id !== moduleID));

      showNotification("Module deleted successfully", "success");
    } catch (error) {
      showNotification(error, "danger");
    }
  };

  class CancelDragPointerSensor extends PointerSensor {
    static activators = [
      {
        eventName: "onPointerDown",
        handler: ({ nativeEvent }) => {
          const t = nativeEvent.target;
          if (
            t &&
            typeof t.closest === "function" &&
            t.closest('[data-no-dnd="true"]')
          ) {
            return false; // ❌ do not activate drag
          }
          return true; // ✅ allow drag
        },
      },
    ];
  }
  const [publishAlert, setPublishAlert] = useState(false);

  const handleCancelPublish = () => {
    setPublishAlert(false);
  };

  const handleConfirmPublish = () => {
    setPublishAlert(false);
    handlePublishCourse();
  };
  const modulesToPublish = course.modules.filter(
    ({ status }) => status === "In Publishing Queue" || status === "Published"
  );
  const artifactsToPublish = additionalArtifacts;
  // Build once per data change, not every render
  const displayProjectItems = useMemo(() => {
    const moduleCards = (displayModules || []).map((m) => ({
      kind: "module",
      id: m.module_id || m._id,
      name: m.module_name,
      description: m.module_description,
      image: course.course_image || images("./qcreate_logo.png"),
      linkPath: `${url}/module/${m.module_id || m._id}`, // fallback safe
      statusText: m.status,
      artifactType: null,
    }));

    const artifactCards = (displayAdditionalArtifacts || []).map((a) => {
      let artifactPath = `/create/${a.artifact_type}/${a.artifact_id}`;
      if (a.artifact_type === "Writing") {
        artifactPath = `/create/${a.artifact_type}/${a.artifact_id}`;
      } else if (a.artifact_type === "podcast") {
        artifactPath = `/create/podcastdesign/podcast/${a.artifact_id}`;
      } else if (a.artifact_type === "Lab") {
        artifactPath = `/create/labdesign/lab/${a.artifact_id}`;
      }

      return {
        kind: "artifact",
        id: a.artifact_id,
        name: a.artifact_name,
        description: a.artifact_description,
        image: course.course_image || images("./qcreate_logo.png"),
        linkPath: artifactPath,
        statusText: a.artifact_type,
        artifactType: a.artifact_type,
      };
    });

    const cards = [...moduleCards, ...artifactCards];
    if (DEBUG) {
      // prints only when list actually changes
      try {
        // compact table
        const rows = cards.map(({ id, linkPath, kind, name }) => ({
          id,
          linkPath,
          kind,
          name,
        }));
        // eslint-disable-next-line no-console
        console.table(rows);
      } catch {}
    }
    return cards;
    // deps kept tight; don't include derived state here
  }, [displayModules, displayAdditionalArtifacts, course.course_image, url]);

  // --- keep order purely in state (no localStorage) ---
  const [orderIds, setOrderIds] = useState([]);

  useEffect(() => {
    const incomingIds = (displayProjectItems || []).map((i) => i.id);

    setOrderIds((prev = []) => {
      if (prev.length === 0) return incomingIds;
      const kept = prev.filter((id) => incomingIds.includes(id));
      const added = incomingIds.filter((id) => !prev.includes(id));
      const next = [...kept, ...added];
      return arraysEqual(prev, next) ? prev : next;
    });
  }, [displayProjectItems]);

  // Derive the render list from displayProjectItems + orderIds
  const [projectItems, setProjectItems] = useState([]);
  useEffect(() => {
    const byId = new Map((displayProjectItems || []).map((it) => [it.id, it]));
    const ordered = (orderIds || []).map((id) => byId.get(id)).filter(Boolean);
    const missing = (displayProjectItems || []).filter(
      (it) => !orderIds.includes(it.id)
    );
    const next = [...ordered, ...missing];

    setProjectItems((prev = []) => (itemsEqualById(prev, next) ? prev : next));
  }, [displayProjectItems, orderIds]);

  useEffect(() => {
    if (!orderIds || orderIds.length === 0) return;

    (async () => {
      try {
        const fd = new FormData();
        fd.append("course_id", courseID);
        // FastAPI expects repeated fields for List[str]
        orderIds.forEach((id) => fd.append("item_ids", id));

        const res = await fetch(
          `${process.env.REACT_APP_FASTAPI_URL}/reorder_course_items`,
          {
            method: "POST",
            body: fd, // no manual Content-Type
          }
        );

        if (!res.ok) {
          const msg = await res.text().catch(() => "Failed to save order");
          throw new Error(msg);
        }
        // Optional: showNotification("Order saved", "success");
      } catch (err) {
        console.error("Order save error:", err);
      }
    })();
  }, [orderIds, courseID]);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } })
  );

  const [activeId, setActiveId] = useState(null);
  const [overlaySize, setOverlaySize] = useState({ width: 0, height: 0 });

  const activeItem = useMemo(
    () => (projectItems || []).find((i) => i.id === activeId),
    [activeId, projectItems]
  );

  const onDragStart = ({ active }) => {
    setActiveId(active.id);
    const el = document.querySelector(`[data-dnd-id="${active.id}"]`);
    if (el) {
      const r = el.getBoundingClientRect();
      setOverlaySize({ width: r.width, height: r.height });
    }
  };
  const onDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      setActiveId(null);
      return;
    }

    const current = projectItems || [];
    const currentIds = current.map((i) => i.id);

    const oldIndex = currentIds.indexOf(active.id);
    const newIndex = currentIds.indexOf(over.id);
    if (oldIndex === -1 || newIndex === -1) {
      setActiveId(null);
      return;
    }

    const newItems = arrayMove(current, oldIndex, newIndex);
    const newIds = newItems.map((i) => i.id);

    // Ensure order updates in the same paint as the drop
    // If you don't have React 18, just call setProjectItems + setOrderIds without flushSync.
    setProjectItems(newItems);
    setOrderIds(newIds);
    setActiveId(null);
  };

  const onDragCancel = () => setActiveId(null);
  const ids = useMemo(() => (projectItems || []).map((i) => i.id), [
    projectItems,
  ]);

  // Cancel drag when pointer starts on an element with data-no-dnd="true"

  // Show loading spinner while modules are loading
  if (modulesLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
      >
        <CircularProgress
          color="quCreateColor"
          className={classes.loaderClass}
        />
        <Typography
          variant="h6"
          style={{ marginLeft: 16, textTransform: "none" }}
        >
          Loading Modules...
        </Typography>
      </Box>
    );
  }
  function SortableProjectCard({ item, onDelete, project, getStatusIcon }) {
    const id = item.id;

    // Make the entire card draggable
    const {
      attributes,
      listeners,
      setNodeRef,
      transform,
      transition,
      isDragging,
    } = useSortable({ id });

    const wrapperStyle = {
      transform: CSS.Transform.toString(transform),
      transition,
      width: "100%",
      zIndex: isDragging ? 2 : 0,
      cursor: isDragging ? "grabbing" : "grab",
      // allow dnd-kit to take over pointer gestures reliably
      touchAction: "none",
    };

    const isModule = item.kind === "module";

    return (
      <GridItem xs={12} sm={12} md={6} lg={6} xl={4}>
        {/* ✅ listeners on the wrapper so the WHOLE card can be dragged */}
        <div
          ref={setNodeRef}
          data-dnd-id={id}
          style={wrapperStyle}
          {...attributes}
          {...listeners}
        >
          <Card
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              border: "2px solid #20677b",
              boxShadow: isDragging ? "0 8px 24px rgba(0,0,0,0.2)" : undefined,
              transition: "box-shadow 120ms ease",
              opacity: isDragging ? 0 : 1, // you use DragOverlay for the preview
            }}
          >
            {/* Keep the drag icon for affordance */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 8,
                padding: "8px 12px 0",
                pointerEvents: "none",
              }}
            >
              <span style={{ display: "inline-flex" }}>
                <DragIndicatorIcon fontSize="medium" />
              </span>
            </div>

            {/* Do NOT stop propagation on the Link; distance constraint will prevent accidental drags.
              This keeps the whole card draggable AND the link clickable. */}
            <Link
              to={{ pathname: item.linkPath, state: { project } }}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <CardHeader
                icon
                style={{ zIndex: 0, paddingRight: 40, marginTop: "-30px" }}
              >
                <CardTitle color="quCreateColor">{item.name}</CardTitle>
              </CardHeader>
              <br />
              <br />

              <NewCardBody image={item.image}>{item.description}</NewCardBody>
            </Link>

            <CardFooter stats style={{ marginTop: "auto", paddingBottom: 10 }}>
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Tooltip title={item.statusText} arrow>
                  <Typography
                    variant="body2"
                    style={{
                      color: "#435966",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      maxWidth: "calc(100% - 60px)",
                    }}
                  >
                    {isModule ? (
                      <>{getStatusIcon(item.statusText)}&nbsp;</>
                    ) : null}
                    {item.statusText}
                  </Typography>
                </Tooltip>

                {/* Delete stays clickable and won't start a drag */}
                <IconButton
                  aria-label={`Delete ${item.name}`}
                  size="small"
                  onPointerDown={(e) => e.stopPropagation()}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                  }}
                >
                  <Icon>delete</Icon>
                </IconButton>
              </div>
            </CardFooter>
          </Card>
        </div>
      </GridItem>
    );
  }

  return (
    <div>
      {publishAlert && (
        <Alert
          title="Publish project to QuSkillBridge?"
          warning
          style={{ display: "block" }}
          showCancel
          cancelBtnText="No"
          confirmBtnText="Yes"
          onCancel={handleCancelPublish}
          onConfirm={handleConfirmPublish}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              justifyContent: "left",
              textAlign: "left",
            }}
          >
            <p>
              You're about to publish <strong>{course.course_name}</strong>. All
              items listed below will be published to QuSkillBridge.
            </p>

            <ul style={{ marginTop: 0 }}>
              {projectItems
                .filter(
                  ({ statusText }) =>
                    statusText === "In Publishing Queue" ||
                    statusText === "Published" ||
                    statusText === "Lab"
                )
                .map((a) => (
                  <li key={a.id || a.name}>{a.name}</li>
                ))}
            </ul>

            <p style={{ marginTop: 16, fontStyle: "italic" }}>
              This action can't be undone.
            </p>
          </div>
        </Alert>
      )}
      {showAlert && (
        <Alert
          title="Are you sure?"
          warning={true}
          showCancel={true}
          cancelBtnText="No"
          confirmBtnText="Yes"
          onCancel={handleCancel}
          onConfirm={handleConfirm}
        >
          {moduleToDelete
            ? "Are you sure you want to delete this module? You will not be able to recover it."
            : "Are you sure you want to delete this artifact? Removing the artifact will only remove it from this project. You can import it again later."}
        </Alert>
      )}

      <CreatePodcastModal
        newPodcastDetails={newPodcastDetails}
        setNewPodcastDetails={setNewPodcastDetails}
        iconImage={iconImage}
        createPodcastModal={createPodcastModal}
        handleCreatePodcastModalClose={handleAssetModalClose}
        handleCreatePodcast={handleCreatePodcast}
        handleIconUpload={handleIconUpload}
        podcastCreationLoader={podcastCreationLoader}
      />

      <CreateLabModal
        newLabDetails={newLabDetails}
        setNewLabDetails={setNewLabDetails}
        createLabModal={createLabModal}
        handleCreateLabModalClose={handleAssetModalClose}
        handleCreateLab={handleCreateLab}
      />

      <CreateWritingModal
        identifier={identifier}
        identifierPrint={identifierPrint}
        newWritingDetails={newWritingDetails}
        setNewWritingDetails={setNewWritingDetails}
        writingId={writingId}
        setWritingId={setWritingId}
        createWritingModal={createWritingModal}
        handleCreateWritingModalClose={handleAssetModalClose}
        handleCreateWriting={handleCreateWriting}
        handleIconUpload={handleIconUpload}
        iconImage={iconImage}
        writingCreationLoader={writingCreationLoader}
        setWritingCreationLoader={setWritingCreationLoader}
        currentDialog={currentDialog}
        setCurrentDialog={setCurrentDialog}
        handleGenerateTemplate={handleGenerateTemplate}
      />

      <CreateModuleModal
        moduleModal={moduleModal}
        handleClose={handleAssetModalClose}
        submitModuleLoading={submitModuleLoading}
        moduleDetails={moduleDetails}
        setModuleDetails={setModuleDetails}
        addModule={addModule}
      />

      {/* Dialog for importing artifact */}
      <Dialog
        open={importModal}
        onClose={() => {
          setImportModal(false);
          setSelectedIds([]);
        }}
        maxWidth="lg"
        fullWidth={true}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ paddingBottom: "0px" }}>
          <div style={{ fontSize: "30px" }}>Import Artifact</div>
          <Divider style={{ margin: "10px 0" }} />
          <Typography variant="body1" style={{ marginTop: "10px" }}>
            You can import an artifact from the list below to add it to your
            project. Please select an artifact and click "Import" to proceed.
          </Typography>
        </DialogTitle>
        {importLoading.loading ? (
          <>
            <DialogContent
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px 0",
              }}
            >
              <CircularProgress size={20} style={{ marginRight: "10px" }} />
              <Typography variant="body1" style={{ fontSize: "16px" }}>
                {importLoading.message}
              </Typography>
            </DialogContent>
          </>
        ) : (
          <>
            <DialogContent>
              {/* Tabs for artifact types */}
              <Tabs
                value={selectedTab}
                onChange={(event, newValue) => setSelectedTab(newValue)}
                variant="scrollable"
                scrollButtons="auto"
                TabIndicatorProps={{
                  style: {
                    backgroundColor: quCreateColor,
                    marginBottom: "10px",
                  },
                }}
              >
                {artifactTypes.map((type) => (
                  <Tab key={type} label={type.replace("_", " ")} value={type} />
                ))}
              </Tabs>
              <ArtifactTable
                data={filteredArtifacts}
                selectedIds={selectedIds}
                onChangeSelected={setSelectedIds}
              />
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => {
                  setImportModal(false);
                  setSelectedIds([]);
                }}
                color="quSandBoxColor"
                disabled={importLoading.loading}
              >
                Cancel
              </Button>
              <Button
                onClick={importArtifacts}
                color="quCreateColor"
                disabled={importLoading.loading || selectedIds.length < 1}
              >
                Import
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>

      <CreateAssetDialog
        open={assetModal}
        handleClose={handleAssetModalClose}
        submitModuleLoading={submitModuleLoading}
        name={name}
        setName={setName}
        brief={brief}
        setBrief={setBrief}
        addAsset={addAsset}
      />

      {alert}

      <Switch>
        <Route exact path={path}>
          <div>
            <Divider style={{ marginBottom: "20px" }} />
            <HeadingWithDescription
              title={course.course_name}
              shortDescription={course.course_description}
              longDescription={course.course_outline}
              textAlign="left"
              identifier="project"
              onChange={handleCourseDetailsChange}
              showImportIcon={true}
              setImportModal={setImportModal}
              showCreateIcon={true}
              setAssetModal={setAssetModal}
              showPublishIcon={true}
              setPublishAlert={setPublishAlert}
            />
            <Divider style={{ marginBottom: "20px" }} />
            <SearchBar
              style={{ marginBottom: "20px" }}
              value={searchValue}
              onChange={(newValue) => searchInputValue(newValue)}
              onRequestSearch={(newValue) => searchInputValue(newValue)}
            />
          </div>
          <GridContainer xs={{ border: 5 }}>
            <GridContainer xs={{ border: 5 }}>
              <GridItem
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {displayProjectItems.length === 0 && (
                  <h3>
                    No modules or artifacts found. Create one or import
                    artifacts to get started.
                  </h3>
                )}
              </GridItem>

              {/* Drag & drop list (dnd-kit) */}
              {/* Drag & drop list (dnd-kit) */}
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragStart={onDragStart}
                onDragEnd={onDragEnd}
                onDragCancel={onDragCancel}
              >
                <SortableContext items={ids} strategy={rectSortingStrategy}>
                  <GridContainer style={{ alignItems: "stretch", padding: 25 }}>
                    {(projectItems || []).map((item) => {
                      const isModule = item.kind === "module";
                      const handleDelete = () => {
                        setShowAlert(true);
                        isModule
                          ? setModuleToDelete(item.id)
                          : setArtifactToDelete(item.id);
                      };

                      return (
                        <SortableProjectCard
                          key={item.id}
                          item={item}
                          onDelete={handleDelete}
                          project={project}
                          getStatusIcon={getStatusIcon}
                        />
                      );
                    })}
                  </GridContainer>
                </SortableContext>

                {/* Drag preview that keeps a card-sized width */}
                <DragOverlay dropAnimation={null}>
                  {activeItem ? (
                    <div
                      style={{
                        width: overlaySize.width,
                        height: overlaySize.height,
                        pointerEvents: "none",
                      }}
                    >
                      <Card
                        style={{
                          height: "100%",
                          display: "flex",
                          flexDirection: "column",
                          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "8px 12px 0",
                          }}
                        >
                          <DragIndicatorIcon fontSize="small" />
                        </div>

                        <CardHeader icon text>
                          <CardTitle color="quCreateColor">
                            {activeItem.name}
                          </CardTitle>
                        </CardHeader>
                        <NewCardBody image={activeItem.image}>
                          {activeItem.description}
                        </NewCardBody>

                        <CardFooter
                          stats
                          style={{ marginTop: "auto", paddingBottom: 10 }}
                        >
                          <div
                            style={{
                              display: "flex",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <Tooltip title={activeItem.statusText} arrow>
                              <Typography
                                variant="body2"
                                style={{
                                  color: "#435966",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "calc(100% - 60px)",
                                }}
                              >
                                {activeItem.kind === "module" ? (
                                  <>
                                    {getStatusIcon(activeItem.statusText)}&nbsp;
                                  </>
                                ) : null}
                                {activeItem.statusText}
                              </Typography>
                            </Tooltip>
                            {/* spacer to mirror delete icon area */}
                            <span style={{ width: 24 }} />
                          </div>
                        </CardFooter>
                      </Card>
                    </div>
                  ) : null}
                </DragOverlay>
              </DndContext>
            </GridContainer>
          </GridContainer>
        </Route>
      </Switch>
    </div>
  );
}
